var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "expandable-box",
    class: {
      expanded: _vm.opened
    }
  }, [_c('button', {
    staticClass: "accordion-title",
    attrs: {
      "title": "Аккордеон"
    },
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v("Accordion Title")]), _vm._v(" "), _c('span', {
    staticClass: "text-message"
  }, [_vm._v("Vivamus eget ante bibendum arcu vehicula ultricies. Integer venenatis mattis nisl, vitae pulvinar dui tempor.Ut eleifend libero sed neque rhoncus consequat. Maecenas tincidunt, augue et rutrum condimentum, libero lectus mattis orci, ut commodo.")])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c325ff1","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/extract-loader/lib/extractLoader.js!./node_modules/html-loader?{"interpolate":true,"attrs":[":url","link:href","source:src"]}!./src/components/expandable-box/expandable-box.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2c325ff1","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/extract-loader/lib/extractLoader.js!./node_modules/html-loader/index.js?{"interpolate":true,"attrs":[":url","link:href","source:src"]}!./src/components/expandable-box/expandable-box.vue
// module chunks = index